/* Dealora Premium – interacțiuni */
(function () {
  'use strict';

  var cfg = window.Dealora || {};
  if (cfg.hideReleasitButton) document.body.classList.add('hide-rsi');

  function money(cents) {
    var parts = (Math.max(0, cents) / 100).toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts.join(',') + ' lei';
  }

  /* ---------- header ---------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 10); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var menu = header.querySelector('[data-menu]');
    var openBtn = header.querySelector('[data-menu-open]');
    var closeMenu = function () {
      menu.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
    };
    if (menu && openBtn) {
      openBtn.addEventListener('click', function () {
        menu.hidden = false;
        openBtn.setAttribute('aria-expanded', 'true');
        document.documentElement.style.overflow = 'hidden';
      });
      header.querySelector('[data-menu-close]').addEventListener('click', closeMenu);
      menu.addEventListener('click', function (e) { if (e.target === menu) closeMenu(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) closeMenu(); });
    }
  }

  /* ---------- pagina de produs ---------- */
  var root = document.querySelector('[data-product]');
  if (root) initProduct(root);

  function initProduct(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = root.querySelector('form.product-form');
    var idInput = root.querySelector('[data-variant-input]');
    var qtyInput = root.querySelector('[data-qty-input]');
    var variant = product.variants.find(function (v) { return idInput && String(v.id) === idInput.value; }) || product.variants[0];

    /* galerie */
    var track = root.querySelector('[data-gallery-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.gallery__dots i'));

    function markSlide(i) {
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
    }
    function goToSlide(i, smooth) {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      markSlide(i);
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goToSlide(i); }); });
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          markSlide(Math.round(track.scrollLeft / track.clientWidth));
        });
      }, { passive: true });
    }
    function showMediaFor(v) {
      if (!v || !v.featured_media) return;
      var idx = slides.findIndex(function (s) { return s.dataset.mediaId === String(v.featured_media.id); });
      if (idx > -1) goToSlide(idx);
    }
    if (variant && variant.featured_media && slides.length && slides[0].dataset.mediaId !== String(variant.featured_media.id)) {
      var i0 = slides.findIndex(function (s) { return s.dataset.mediaId === String(variant.featured_media.id); });
      if (i0 > 0) requestAnimationFrame(function () { goToSlide(i0, false); });
    }

    /* oferte cantitate */
    var offerInputs = Array.prototype.slice.call(root.querySelectorAll('.offer input[type="radio"]'));
    function currentQty() {
      var c = offerInputs.find(function (i) { return i.checked; });
      return c ? parseInt(c.value, 10) : 1;
    }
    function offerPrice(v, qty, disc) { return Math.floor(v.price * qty * (100 - disc) / 100); }
    function currentTotal() {
      var c = offerInputs.find(function (i) { return i.checked; });
      if (!c) return variant.price;
      return offerPrice(variant, parseInt(c.value, 10), parseInt(c.dataset.disc || '0', 10));
    }
    function renderOffers() {
      offerInputs.forEach(function (inp) {
        var qty = parseInt(inp.value, 10);
        var disc = parseInt(inp.dataset.disc || '0', 10);
        var label = inp.closest('.offer');
        var p = offerPrice(variant, qty, disc);
        var unitCmp = Math.max(variant.compare_at_price || variant.price, variant.price);
        var cmp = unitCmp * qty;
        var priceEl = label.querySelector('[data-offer-price]');
        var cmpEl = label.querySelector('[data-offer-compare]');
        var saveEl = label.querySelector('[data-offer-save]');
        if (priceEl) priceEl.textContent = money(p);
        if (cmpEl) { cmpEl.textContent = money(cmp); cmpEl.hidden = cmp <= p; }
        if (saveEl) saveEl.textContent = ' · Economisești ' + money(variant.price * qty - p);
      });
    }
    function renderTotals() {
      var qty = currentQty();
      if (qtyInput) qtyInput.value = qty;
      var txt = money(currentTotal()) + (qty > 1 ? ' · ' + qty + ' buc.' : '');
      document.querySelectorAll('[data-sticky-price]').forEach(function (el) { el.textContent = txt; });
    }
    offerInputs.forEach(function (inp) {
      inp.addEventListener('change', function () {
        renderTotals();
        if (qtyInput) qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    /* variante */
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]')).filter(function (g) { return g.classList.contains('swatches'); });
    function selectedOptions() {
      var opts = variant ? variant.options.slice() : [];
      groups.forEach(function (g) {
        var pressed = g.querySelector('[aria-pressed="true"]');
        if (pressed) opts[parseInt(g.dataset.optionIndex, 10)] = pressed.dataset.value;
      });
      return opts;
    }
    function updateAvailability() {
      groups.forEach(function (g) {
        var idx = parseInt(g.dataset.optionIndex, 10);
        var sel = selectedOptions();
        g.querySelectorAll('.swatch').forEach(function (b) {
          var test = sel.slice(); test[idx] = b.dataset.value;
          var match = product.variants.find(function (v) { return v.options.every(function (o, k) { return o === test[k]; }); });
          b.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
    }
    function applyVariant(v) {
      if (!v) return;
      variant = v;
      if (idInput) {
        idInput.value = v.id;
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var priceEl = root.querySelector('[data-price]');
      var cmpEl = root.querySelector('[data-compare]');
      var saveEl = root.querySelector('[data-save]');
      if (priceEl) priceEl.textContent = money(v.price);
      var hasCmp = v.compare_at_price && v.compare_at_price > v.price;
      if (cmpEl) { cmpEl.hidden = !hasCmp; if (hasCmp) cmpEl.textContent = money(v.compare_at_price); }
      if (saveEl) { saveEl.hidden = !hasCmp; if (hasCmp) saveEl.textContent = '−' + Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; }
      v.options.forEach(function (val, k) {
        var lab = root.querySelector('[data-option-label="' + k + '"]');
        if (lab) lab.textContent = val;
      });
      document.querySelectorAll('[data-buy]').forEach(function (b) { b.disabled = !v.available; });
      var ctaLabel = root.querySelector('[data-cta-label]');
      if (ctaLabel) {
        if (!ctaLabel.dataset.orig) ctaLabel.dataset.orig = ctaLabel.textContent;
        ctaLabel.textContent = v.available ? ctaLabel.dataset.orig : 'Stoc epuizat';
      }
      renderOffers();
      renderTotals();
      updateAvailability();
      showMediaFor(v);
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* ignorat */ }
    }
    groups.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var btn = e.target.closest('.swatch');
        if (!btn) return;
        g.querySelectorAll('.swatch').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        var sel = selectedOptions();
        var match = product.variants.find(function (v) { return v.options.every(function (o, k) { return o === sel[k]; }); });
        applyVariant(match);
      });
    });

    renderOffers();
    renderTotals();
    updateAvailability();

    /* butoanele „Comandă acum” deschid formularul Releasit */
    function buy() {
      if (!variant || !variant.available) return;
      if (idInput) idInput.value = variant.id;
      if (qtyInput) qtyInput.value = currentQty();
      var rsi = document.getElementById('rsi_buy_now_button');
      if (rsi) { rsi.click(); return; }
      // Fără Releasit: checkout direct doar cu acest produs (nu se adună în coș)
      window.location.href = '/cart/' + variant.id + ':' + currentQty();
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-buy]');
      if (!b) return;
      e.preventDefault();
      buy();
    });

    /* bara fixă pe mobil */
    var sticky = root.querySelector('[data-sticky]');
    var mainCta = root.querySelector('[data-main-cta]');
    if (sticky && mainCta && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(mainCta);
    }
  }

  /* ---------- statistici animate ---------- */
  var nums = document.querySelectorAll('[data-count]');
  if (nums.length && 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var el = en.target;
        var ring = el.closest('.stat__ring');
        var target = parseInt(el.dataset.count, 10);
        var start = null;
        var step = function (ts) {
          if (!start) start = ts;
          var p = Math.min(1, (ts - start) / 1600);
          var eased = 1 - Math.pow(1 - p, 3);
          var val = Math.round(target * eased);
          el.textContent = val + '%';
          if (ring) ring.style.setProperty('--p', val);
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    nums.forEach(function (n) { io.observe(n); });
  }
})();
